import cn from 'classnames';
import { getBarStyles } from './utils';

export type ClinicalDataVerticalBarProps = {
  max: number;
  value: number;
  baseline?: number;
  color: string;
  borderColor?: string;
  label?: string;
  showLabel?: boolean;
  showValue?: boolean;
  maxBarSize?: number;
  cardView?: boolean;
  showMaxValueIndicator?: boolean;
  showBarDiff?: boolean;
  containerClassName?: string;
};

const defaultMaxBarHeight = 60;

export const VerticalBar = ({
  maxBarSize = defaultMaxBarHeight,
  max,
  value,
  label,
  baseline = 0,
  color,
  borderColor = '',
  showValue,
  showLabel,
  cardView,
  showMaxValueIndicator,
  showBarDiff,
  containerClassName = '',
}: ClinicalDataVerticalBarProps) => {
  const { diffBarStyles, barStyles, barSize, diffBarSize } = getBarStyles({
    max,
    baseline,
    color,
    isVertical: true,
    maxBarSize,
    value,
    showBarDiff,
  });
  const showMaxValueLine = value === max && !baseline && showMaxValueIndicator;
  const maxValueBorderStyles = { [`border-t-2 rounded-t-none ${borderColor}`]: showMaxValueLine };
  const containerCn = cn(cardView ? 'min-w-6' : 'min-w-14', 'flex-1 text-center', containerClassName);
  const mainBarCn = cn('flex-1', barStyles, maxValueBorderStyles);
  const barDiffCn = cn(diffBarStyles, 'rounded-t mb-0.5');
  const valueCn = cn(cardView ? 'text-s-sb' : 'text-m-sb');
  const labelCn = cn(cardView ? 'text-xs-r' : 'text-m-r', 'text-base-30');

  return (
    <div className={containerCn}>
      {!!baseline && showBarDiff && <div style={{ height: diffBarSize }} className={barDiffCn} />}
      <div style={{ height: barSize }} className={mainBarCn} />
      {showValue && <div className={valueCn}>{value}</div>}
      {showLabel && <div className={labelCn}>{label}</div>}
    </div>
  );
};
